
import { FamilyProfile } from "./types";

// Save to localStorage
export function saveFamilyProfileToLocalStorage(profile: FamilyProfile): void {
  localStorage.setItem('familyProfile', JSON.stringify(profile));
  localStorage.setItem('familyProfileLastModified', new Date().toISOString());
}

// Get from localStorage
export function getFamilyProfileFromLocalStorage(): FamilyProfile | null {
  const profile = localStorage.getItem('familyProfile');
  return profile ? JSON.parse(profile) : null;
}

// Check if exists in localStorage
export function hasFamilyProfileInLocalStorage(): boolean {
  return localStorage.getItem('familyProfile') !== null;
}
